import camelCase from 'lodash/camelCase';
import { Signature, Signer } from 'services/documents/ts/types';

import { EDRPOU_PATTERN } from '../constants';

export const checkIsValidEdrpou = (edrpouValue: string) =>
    !!edrpouValue && EDRPOU_PATTERN.test(edrpouValue.trim());

export const getSignerGroupBySignatureRoleId = (
    signers?: Signer[],
    signature?: Signature,
) =>
    signers?.find((signer) => signer.groupSignerId === signature?.roleId) ||
    null;

/*
 * This function is used to remove duplicates from an array of objects by a specific key
 * @param arr - array of objects
 * @param predicate - key to remove duplicates by
 * @returns - array of objects without duplicates
 */
export function uniqBy<T>(arr: T[], predicate: (item: T) => string): T[] {
    const seen = new Set<string>();
    return arr.filter((item) => {
        const key = predicate(item);
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });
}

export const convertToCamelCase = (
    obj: Nullable<Record<string, any> | string>,
) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const camelKey = camelCase(key);

            if (
                typeof obj[key] === 'object' &&
                obj[key] !== null &&
                !Array.isArray(obj[key])
            ) {
                obj[camelKey] = convertToCamelCase(obj[key]);
            } else {
                obj[camelKey] = obj[key];
            }

            if (camelKey !== key) {
                delete obj[key];
            }
        }
    }

    return obj;
};
